import React, { useState } from 'react';
import './UserPage.css'; // Add styles for the User Page
import { db } from '../firebase'; // Import Firestore instance
import { collection, addDoc } from 'firebase/firestore';
import emailjs from 'emailjs-com'; // Import EmailJS
import { useParams } from 'react-router-dom'; // Import useParams to retrieve eventId from the URL

function UserPage() {
  const { eventId } = useParams(); // Retrieve eventId from the URL
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
  
    console.log('Event ID:', eventId); // Debugging log
  
    if (!name || !email) {
      setErrorMessage('Please fill in all fields.');
      return;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage('Please enter a valid email address.');
      return;
    }
  
    if (!eventId) {
      setErrorMessage('Event ID is missing.');
      return;
    }
  
    try {
      // Save user details to Firestore
      await addDoc(collection(db, 'eventAlerts'), {
        name,
        email,
        eventId,
        createdAt: new Date().toISOString(),
      });
  
      // Prepare template parameters for EmailJS
      const templateParams = {
        user_name: name,
        event_title: `Event ID: ${eventId}`,
        to_email: email, // This must match the "To" field variable in your template
      };
  
      console.log('Template Params:', templateParams); // Debugging log
  
      // Send alert email using EmailJS
      const response = await emailjs.send(
        'service_1ag42sn', // Replace with your EmailJS service ID
        'template_nlmqmbu', // Replace with your EmailJS template ID
        templateParams,
        '46V6J71EycK6R2OJ7' // Replace with your EmailJS user ID
      );
  
      console.log('EmailJS Response:', response);
  
      setSuccessMessage(
        'You have successfully signed up to receive notifications for this event. Make sure to check your email for event updates!'
      );
      setName('');
      setEmail('');
      setErrorMessage('');
    } catch (error) {
      console.error('Error signing up for alerts:', error);
      setErrorMessage('Failed to sign up. Please try again.');
    }
  };

  return (
    <div className="user-page-container">
      <h1>Sign Up for Event Alerts</h1>
      <form onSubmit={handleSignup} className="signup-form">
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            aria-label="Name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            aria-label="Email Address"
          />
        </div>
        <button type="submit" className="signup-button">
          Sign Up
        </button>
      </form>
      {successMessage && <p className="success-message">{successMessage}</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

export default UserPage;